import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/")({
  loader: ({ location }) => {
    if (location.pathname === "/procurement/purchase-orders") {
      throw redirect({
        to: "/procurement/purchase-orders/draft",
      })
    }
    return null
  },
})
